export enum FrontendBillableItemTypes {
  EVENT_CREATED = 'event_created',
}
